import moment from 'moment-timezone';
import React from 'react';
import { useTranslations } from '@lang';
import { DATE_FORMAT, XS_DATE_FORMAT } from '../constants';
import { Input, InputWrapper, DummyButton, StyledArrowWrapper } from './DateRangeInputs.styles';
import { StyledArrow } from '../DateRangeInput.styles';
import { isXxsMobile } from '@utils/grid';

export const DateRangeInputs = ({ inputStartDate, onClick, endDate }) => {
  const { t } = useTranslations();
  const dateFormat = isXxsMobile() ? XS_DATE_FORMAT : DATE_FORMAT;
  return (
    <InputWrapper>
      {/* Dummy button here to catch focus on mobile input when closing calendar */}
      <DummyButton />
      <Input
        onClick={onClick}
        aria-label={t('common.startDate')}
        type="text"
        value={moment(inputStartDate).format(dateFormat)}
        readOnly
      />
      <StyledArrowWrapper>
        <StyledArrow width="18" height="18" />
      </StyledArrowWrapper>
      <Input
        onClick={onClick}
        aria-label={t('common.endDate')}
        type="text"
        value={moment(endDate).format(dateFormat)}
        readOnly
      />
    </InputWrapper>
  );
};
